<template>
  <!-- 应收款明细表 -->
  <div style="margin: 10px">
    <div>
      <div style="margin-bottom: 5px; margin-top: 5px">
        <el-button @click="excelPost(1)"> 纵向打印 </el-button>
        <el-button @click="excelPost(2)">
          应收款账龄分析表(按小区汇总)
        </el-button>
        <el-button @click="excelPost(3)">
          应收款账龄分析表(按收费项目汇总)
        </el-button>
        <el-button @click="excelPost(4)"> 账龄分析项目统计表 </el-button>
        <el-button @click="excelPost(5)"> 应收款账龄分析表(审计用) </el-button>
        <el-button @click="excelPost(6)" v-if="ERP.isPermission(4013001)" > 应收款账龄分析表(开发) </el-button>
      </div>

      <div class="cdj_div" style="margin-top: 20px">欠费明细表-查询条件</div>
      <el-descriptions
        :column="2"
        border
        size="mini"
        :labelStyle="{ width: '123px', color: 'black' }"
        :contentStyle="{ width: '42%' }"
      >
        <el-descriptions-item label="计费周期">
          <el-date-picker
            size="mini"
            v-model="startDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="开始时间"
          ></el-date-picker>
          <span class="cdj_text_data">至</span>
          <el-date-picker
            size="mini"
            v-model="endDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="结束时间"
          ></el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="房产">
          <div style="display: flex">
            <div
              @click="houses"
              v-if="data.house"
              style="cursor: pointer; color: red"
              :class="data.house.length > 30 ? 'dade-text' : ''"
            >
              {{ data.house }}
            </div>
            <div
              @click="houses_del"
              v-if="data.house"
              style="cursor: pointer; margin-left: 10px"
            >
              取消选择
            </div>
            <div @click="houses" v-else style="cursor: pointer">
              选择房产...
            </div>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="应收日期">
          <el-date-picker
            size="mini"
            v-model="shouldStartDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="开始时间"
          ></el-date-picker>
          <span class="cdj_text_data">至</span>
          <el-date-picker
            size="mini"
            v-model="shouldEndDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="结束时间"
          ></el-date-picker>
        </el-descriptions-item>

        <el-descriptions-item label="客户">
          <div style="display: flex">
            <el-input
              style="width: 80%"
              v-model="data.user"
              placeholder="客户姓名"
            ></el-input>
            <el-button @click="user">选择客户</el-button>
          </div>
        </el-descriptions-item>

        <el-descriptions-item label="已收日期">
          <el-date-picker
            size="mini"
            v-model="operatorStartDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="开始时间"
          ></el-date-picker>
          <span class="cdj_text_data">至</span>
          <el-date-picker
            size="mini"
            v-model="operatorEndDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="结束时间"
          ></el-date-picker>
        </el-descriptions-item>

        <el-descriptions-item label="费用类型">
          <div style="display: flex">
            <div
              @click="chargeitems"
              v-if="data.chargeitemIDName"
              style="cursor: pointer; color: red"
              :class="data.chargeitemIDName.length > 30 ? 'dade-text' : ''"
            >
              {{ data.chargeitemIDName }}
            </div>
            <div
              @click="chargeitems_del"
              v-if="data.chargeitemIDName"
              style="cursor: pointer; margin-left: 10px"
            >
              取消选择
            </div>
            <div @click="chargeitems" v-else style="cursor: pointer">
              选择收费项目...
            </div>
          </div>
        </el-descriptions-item>

        <el-descriptions-item label="所属日期">
          <el-date-picker
            size="mini"
            v-model="monthStartDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="开始时间"
          ></el-date-picker>
          <span class="cdj_text_data">至</span>
          <el-date-picker
            size="mini"
            v-model="monthEndDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="结束时间"
          ></el-date-picker>
        </el-descriptions-item>

        <el-descriptions-item label="收费标准">
          <div style="display: flex">
            <div
              @click="charge"
              v-if="data.chargeName"
              style="cursor: pointer; color: red"
              :class="data.chargeName.length > 30 ? 'dade-text' : ''"
            >
              {{ data.chargeName }}
            </div>
            <div
              @click="charge_del"
              v-if="data.chargeName"
              style="cursor: pointer; margin-left: 10px"
            >
              取消选择
            </div>
            <div @click="charge" v-else style="cursor: pointer">
              选择收费标准...
            </div>
          </div>
        </el-descriptions-item>

        <el-descriptions-item label="客户类型">
          <CheckboxGroup v-model="data.userType">
            <Checkbox label="1" style="font-weight: 500">业主</Checkbox>
            <Checkbox label="2" style="font-weight: 500">租户</Checkbox>
            <Checkbox label="3" style="font-weight: 500">住户</Checkbox>
            <Checkbox label="4" style="font-weight: 500">共有人</Checkbox>
            <Checkbox label="5" style="font-weight: 500">开发商</Checkbox>
            <Checkbox label="9" style="font-weight: 500">其它</Checkbox>
          </CheckboxGroup>
        </el-descriptions-item>

        <el-descriptions-item label="显示方式">
          <Space direction="vertical" size="large">
            <RadioGroup v-model="data.display">
              <Radio label="1" style="font-weight: 500">按房产排序</Radio>
              <Radio label="2" style="font-weight: 500">按客户排序</Radio>
              <!-- <Radio label="按客户汇总" style="font-weight:500"></Radio> -->
            </RadioGroup>
          </Space>
        </el-descriptions-item>

        <el-descriptions-item label="房间状态">
          <div style="display: flex">
            <div
              @click="roomstatus"
              style="cursor: pointer; color: red"
              v-if="data.room"
              :class="data.room.length > 30 ? 'dade-text' : ''"
            >
              {{ data.room }}
            </div>
            <div
              @click="roomstatus_del"
              v-if="data.room"
              style="cursor: pointer; margin-left: 10px"
            >
              取消选择
            </div>
            <div @click="roomstatus" v-else style="cursor: pointer">
              选择房间状态...
            </div>
          </div>
        </el-descriptions-item>

        <el-descriptions-item label="统计方式">
          <Space direction="vertical" size="large">
            <RadioGroup v-model="data.excel">
              <Radio label="1" style="font-weight: 500">按计费周期合并</Radio>
              <Radio label="2" style="font-weight: 500">按计费周期明细</Radio>
              <Radio label="3" style="font-weight: 500" disabled
                >按项目计费周期合并</Radio
              >
            </RadioGroup>
          </Space>
        </el-descriptions-item>
        <el-descriptions-item label="是否统计明细信息">
          <Space direction="vertical" size="large">
            <RadioGroup v-model="data.countDetail">
              <Radio label="1" style="font-weight: 500">否</Radio>
              <Radio label="2" style="font-weight: 500">是</Radio>
            </RadioGroup>
          </Space>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <!-- 房产 -->
    <house ref="house"></house>
    <!-- 收费项目 -->
    <Chargeitem ref="chargeitem" @chargeitemAll="chargeitemAll"></Chargeitem>
    <!-- 收费标准 -->
    <Charge ref="charges" @chargesAll="chargesAll"></Charge>
    <!-- 房间状态 -->
    <RoomStatus ref="roomstatu" @roomstatuAll="roomstatuAll"></RoomStatus>
    <!-- 弹窗选择用户 -->
    <Modal v-model="modal1" width="800" title="选择客户" @on-ok="roomUser">
      <div>
        <room-user
          style="height: 600px"
          ref="child"
          :house="house_1"
        ></room-user>
      </div>
    </Modal>
    <excel-task
      ref="ExcelTask"
      :excelTask="excelTask"
      :excelTaskId="excelTaskId"
      @close="closeExcelTask"
    />
  </div>
</template>

<script>
import imgurl from "../../../assets/js/imgurl.js";
import ExcelTask from "@/components/common/excelTask";
export default {
  name: "FormsOweMoney",
  data() {
    return {
      modal1: false,
      house_1: "",
      loading: false,
      data: {
        startDate: "",
        endDate: "",
        house_id: "",
        house: "",
        shouldStartDate: "",
        shouldEndDate: "",
        user: "",
        user_id: "",
        operatorStartDate: "",
        operatorEndDate: "",
        monthStartDate: "",
        monthEndDate: "",
        chargeitemID: "",
        chargeitemIDName: "",
        userType: [],
        charge_id: "",
        chargeName: "",
        excel: "1",
        room: "",
        room_id: "",
        display: "1",
        countDetail: "1",
      },
      excelTaskId: "",
      excelTask: false,
      shouldStartDate: "",
      shouldEndDate: "",
      operatorStartDate: "",
      operatorEndDate: "",
      monthStartDate: "",
      monthEndDate: "",
      startDate: "",
      endDate: "",
    };
  },
  //界面没出来前加载
  created() {},
  // 加载数据
  mounted() {},
  computed: {
    __TABLE_HEIGHT__() {
      return ERP.getStore().__TABLE_HEIGHT__;
    },
  },
  //事件
  methods: {
    //选择客户
    user() {
      this.house_1 = "";
      this.modal1 = true;
    },
    roomUser() {
      let user = this.$refs.child.getUser();
      //console.log(user);
      if (user.id) {
        this.data.user_id = user.id;
        this.data.user = user.name;
      }
    },
    //选择房产
    houses() {
      let _this = this;
      this.$refs.house.show([], function (data) {
        //整理项目和房产ID
        _this.$myhttp
          .post("admin/common/house_tree_id", data, {
            "Content-Type": "application/x-www-form-urlencoded",
          })
          .then((backdata) => {
            // 异步执行成功后
            _this.data.house_id = backdata.data.house_ids;
            _this.data.house = backdata.data.ancestor_name;
            // _this.data.chargeitemID = "";
            // _this.data.chargeitemIDName = "";
            // _this.data.charge_id = "";
            // _this.data.chargeName = "";
          })
          .catch(function (error) {
            _this.$Message.error("选择房产失败");
          });
      });
    },
    houses_del() {
      this.data.house_id = "";
      this.data.house = "";
    },
    //选择收费项目
    chargeitems() {
      this.$refs.chargeitem.getInvo(this.data);
    },
    chargeitems_del() {
      this.data.chargeitemID = "";
      this.data.chargeitemIDName = "";
    },
    chargeitemAll() {
      let data = this.$refs.chargeitem.getReturn();
      this.data.chargeitemID = data
        .map((ret) => {
          return ret.id;
        })
        .join(",");
      this.data.chargeitemIDName = data
        .map((ret) => {
          return ret.label;
        })
        .join(",");
      this.data.charge_id = "";
      this.data.chargeName = "";
    },
    //选择收费标准
    charge() {
      this.$refs.charges.getInvo(this.data);
    },
    charge_del() {
      this.data.charge_id = "";
      this.data.chargeName = "";
    },
    chargesAll() {
      let data = this.$refs.charges.getReturn();
      this.data.charge_id = data
        .map((ret) => {
          return ret.id;
        })
        .join(",");
      this.data.chargeName = data
        .map((ret) => {
          return ret.label;
        })
        .join(",");
    },
    //房间状态
    roomstatus() {
      this.$refs.roomstatu.getInvo(this.data);
    },
    roomstatus_del() {
      this.data.room_id = "";
      this.data.room = "";
    },
    roomstatuAll() {
      let data = this.$refs.roomstatu.getReturn();
      this.data.room_id = data
        .map((ret) => {
          return ret.id;
        })
        .join(",");
      this.data.room = data
        .map((ret) => {
          return ret.label;
        })
        .join(",");
    },
    //导出
    excelPost(type) {
      let data = this.data;
      if (this.data.house_id == "") {
        this.$Message.error("房产不能为空");
        return false;
      }
      data.targetController = "OweMoneyController"; //控制器
      if (type == 1) {
        if (data.display == "1") {
          data.targetFunction = "excel1";
          data.taskName = "欠费明细表（按房产汇总）";
        } else if (data.display == "2") {
          data.targetFunction = "excel2";
          data.taskName = "欠费明细表（按客户汇总）";
        }
      } else if (type == 2) {
        data.taskName = "应收账龄汇总表（按小区汇总）";
        if (data.countDetail == "1") {
          data.targetFunction = "excel3";
        } else if (data.countDetail == "2") {
          data.targetFunction = "excel4";
        }
      } else if (type == 3) {
        data.taskName = "应收账龄汇总表（按收费项目汇总）";
        data.targetFunction = "excel5";
      } else if (type == 4) {
        data.taskName = "账龄分析项目统计表";
        data.targetFunction = "excel6";
      } else if (type == 5) {
        data.taskName = "应收账龄汇总表（审计用）";
        data.targetFunction = "excel7";
        if (data.countDetail == "1") {
          data.targetFunction = "excel7";
        } else if (data.countDetail == "2") {
          data.targetFunction = "excel8";
        }
        console.log('data',data);
        console.log('this.endDate',this.endDate);
        console.log('this.monthEndDate',this.monthEndDate);
        if (this.endDate == "") {
          this.$Message.error("计费周期结束时间不能为空");
          return false;
        }
        if (this.monthEndDate == "") {
          this.$Message.error("所属日期结束时间不能为空");
          return false;
        }
        if (!this.endDate) {
          this.$Message.error("计费周期结束时间不能为空");
          return false;
        }
        if (!this.monthEndDate) {
          this.$Message.error("所属日期结束时间不能为空");
          return false;
        }
      } else if (type == 6) {
        data.taskName = "应收账龄汇总表（开发）";
        data.targetFunction = "excel10";
        if (data.countDetail == "1") {
          data.targetFunction = "excel10";
        } else if (data.countDetail == "2") {
          data.targetFunction = "excel11";
        }
        console.log('data',data);
        console.log('this.endDate',this.endDate);
        console.log('this.monthEndDate',this.monthEndDate);
        if (this.endDate == "") {
          this.$Message.error("计费周期结束时间不能为空");
          return false;
        }
        if (this.monthEndDate == "") {
          this.$Message.error("所属日期结束时间不能为空");
          return false;
        }
        if (!this.endDate) {
          this.$Message.error("计费周期结束时间不能为空");
          return false;
        }
        if (!this.monthEndDate) {
          this.$Message.error("所属日期结束时间不能为空");
          return false;
        }
      }
      data.type = type;
      data.shouldStartDate = this.shouldStartDate / 1000;
      data.shouldEndDate = this.shouldEndDate / 1000;
      data.operatorStartDate = this.operatorStartDate / 1000;
      data.operatorEndDate = this.operatorEndDate / 1000;
      data.monthStartDate = this.monthStartDate / 1000;
      data.monthEndDate = this.monthEndDate / 1000;
      data.startDate = this.startDate / 1000;
      data.endDate = this.endDate / 1000;
      ERP.showLoading();
      this.$myhttp
        .post("admin/ExcelTask/addTask", data, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          ERP.hideLoading();
          this.$store.commit("excelTaskAdd");
          this.$Message.success("添加导出任务成功");
          var data = backdata.data.data;
          this.excelTaskId = data.excelTaskId;
          this.openExcelTask();
        })
        .catch(function (error) {
          this.$Message.error("操作失败");
          ERP.hideLoading();
        });
    },
    openExcelTask() {
      this.$store.commit("excelTaskClear");
      this.excelTask = true;
      this.$refs.ExcelTask.change(1);
    },
    closeExcelTask() {
      this.excelTask = false;
    },
  },
  watch: {},
  components: {
    "room-user": () => import("../Common/room-user.vue"),
    house: () => import("./common/SelectProjectHouse.vue"),
    Chargeitem: () => import("./common/Chargeitem.vue"),
    Charge: () => import("./common/Charge.vue"),
    RoomStatus: () => import("./common/RoomStatus.vue"),
    ExcelTask,
  },
};
</script>
<style scoped>
@import "../../../assets/css/table.css";
.ti {
  margin: 1%;
  width: 98%;
}

.text1 {
  text-align: center;
}

.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}

.search {
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}

.text2 {
  color: rgb(250, 248, 248);
}

.kuan {
  width: 10%;
}

.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}

.cdj_margin {
  margin-left: 1px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}
.dade-text {
  width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.d-flex-right {
  flex: 1;
}
</style>
sss



// WEBPACK FOOTER //
// src/components/Admin/Forms/oweMoney.vue